import { useMemo } from "react";
import { useSelector } from "react-redux";

interface RootState {
  settings: {
    bigBlueButtonIntegrationEnabled: string;
    bigBlueButtonIntegrationUseInLessons: string;
  };
}

export const IsBbbUseInLessons = (): boolean => {
  const bbbEnabled = useSelector((store: RootState) => 
    store.settings.bigBlueButtonIntegrationEnabled === '1'
  );
  
  const bbbUseInLessons = useSelector((store: RootState) => 
    store.settings.bigBlueButtonIntegrationUseInLessons === '1'
  );
  
  const canUseBbb = useMemo(() => bbbEnabled && bbbUseInLessons, [bbbEnabled, bbbUseInLessons]);

  return canUseBbb;
}